// removed by extract-text-webpack-plugin
module.exports = {"menu-block":"index__menu-block___1b_3_","menuBlock":"index__menu-block___1b_3_","title":"index__title___3AsOb","list":"index__list___1cQeE","item":"index__item___qNDjl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/MenuBlock/index.css
// module id = 978
// module chunks = 37